import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardMedia, Typography, Grid, CircularProgress, Alert, Button, Divider } from '@mui/material';
import axios from 'axios';
import BASE_API_URL from '../apis/index';
import styled from 'styled-components';

function Profile() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const authToken = localStorage.getItem('authToken');
        if (!authToken) {
          setError('You are not logged in');
          setLoading(false);
          return;
        }

        const res = await axios.get(`${BASE_API_URL}/api/user/profile`, {
          headers: { Authorization: `Bearer ${authToken}` }
        });

        setProfile(res.data);
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to fetch profile data');
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  if (loading) return <CircularProgress sx={{ display: 'block', margin: '50px auto' }} />;
  if (error) return <Alert severity="error" sx={{ mt: 3 }}>{error}</Alert>;

  if (!profile) return null;

  return (
    <Wrapper className='container'>
      <Card sx={{ maxWidth: 800, p: 2 }} className='bg-light border-none'>
        <Grid container spacing={2}>
          {/* Profile Image */}
          <Grid>
            <CardMedia
              component="img"
              height="200"
              image={`${BASE_API_URL}/uploads/user_profile_images/${profile.profile_image}`}
              alt={profile.name}
              sx={{
                borderRadius: '10px',
                objectFit: 'cover',
                width: '200px',
                height: 'auto'
              }}
            />
          </Grid>

          {/* Profile Details */}
          <Grid>
            <CardContent>
              <Typography variant="h5" gutterBottom className='txt_color_primary'>{profile.name}</Typography>
              <Typography variant="subtitle1" className="txt_color_secondary">{profile.designation}</Typography>
              <Typography variant="body1" sx={{ mt: 2 }}> <strong>Company:</strong> {profile.company} </Typography>
              <Typography variant="body1"> <strong>Email:</strong> {profile.email} </Typography>
              <Typography variant="body1"> <strong>Mobile:</strong> {profile.mobile} </Typography>
            </CardContent>
          </Grid>
        </Grid>

        <Divider color='warning' className='mb-2' />
        <>
          <Button variant="outlined" href="/edit-profile" color='warning' className='me-2'> Edit Profile </Button>
          <Button variant="outlined" href="/forgot-password" color='warning'> Reset Password </Button>
        </>
      </Card>
    </Wrapper>
  );
}

export default Profile;

const Wrapper = styled.div``